export const SHARES_TABLE_PAGE_SIZE = 5;
export const TESTS_TABLE_PAGE_SIZE = 5;
export const TOKEN_DEADLINE = 300;
